export const SUB_FOLDER ="compsign";
export const UPLOAD_TYPES_SUB_FOLDER ="compsign/uploadTypes";
export const API_PATH ="https://dsabsouvu16fx.cloudfront.net";
export const FILE_API_PATH ="https://production-imagebucket-1qbvp4byyedfy.s3.eu-central-1.amazonaws.com";
